import { createReducer } from '@reduxjs/toolkit';
import authAct, { AuthUserInfo, ProjectInfo, RolePagesMap } from './authAction';
import roleConfig from '../../config/config.role';

export interface AuthToken {
  token: string;
  projectTokens: ProjectInfo[];
  user: AuthUserInfo | null;
  role: string;
  rolePages: RolePagesMap;
  authReady: boolean;
}

const initState: AuthToken = {
  token: '',
  projectTokens: [],
  user: null,
  role: roleConfig.anonymous,
  rolePages: {},
  authReady: false,
};

const authReducer = createReducer(initState, (builder) => {
  builder.addCase(authAct.SET_TOKEN, (state, action) => ({
    ...state,
    token: action.payload,
  }));
  builder.addCase(authAct.CLEAR_TOKEN, (state) => ({
    ...state,
    token: initState.token,
  }));
  builder.addCase(authAct.SET_PRJ_TOKEN, (state, action) => ({
    ...state,
    projectTokens: action.payload,
  }));
  builder.addCase(authAct.CLEAR_PRJ_TOKEN, (state) => ({
    ...state,
    projectTokens: initState.projectTokens,
  }));
  builder.addCase(authAct.SET_USER, (state, action) => ({
    ...state,
    user: action.payload,
  }));
  builder.addCase(authAct.CLEAR_USER, (state) => ({
    ...state,
    user: initState.user,
  }));
  builder.addCase(authAct.SET_ROLE, (state, action) => ({
    ...state,
    role: action.payload || initState.role,
  }));
  builder.addCase(authAct.SET_ROLE_PAGES, (state, action) => ({
    ...state,
    rolePages: action.payload || initState.rolePages,
  }));
  builder.addCase(authAct.SET_AUTH_READY, (state, action) => ({
    ...state,
    authReady: action.payload,
  }));
});

export default authReducer;
